<template>
  <div class="customPage">
    <h2 class="customPageTitle">챌린지 시작</h2>
    <v-container class="customPageContent">
      <v-text-field 
        v-model="reward" 
        label="상대에게 걸 보상을 입력해주세요"
        prepend-icon="mdi-gift-open-outline"
        hide-details
        maxlength="50"
      ></v-text-field>
      <v-file-input
        id="rewardImage"
        label="보상 이미지를 업로드 해주세요"
        v-model="rewardImage"
        ref="rewardImage"
        type="file"
        accept="image/x-png,image/gif,image/jpeg"
        hide-details
      ></v-file-input>
      <v-text-field 
        v-model="hint" 
        label="힌트를 입력해주세요"
        prepend-icon="mdi-help-circle-outline"
        hide-details
        maxlength="100"
      ></v-text-field>
      <div class="customPageCheckbox">
        <v-checkbox 
          v-model="hintVisible" 
          label="힌트를 공개할까요?"
          hide-details
        ></v-checkbox>
      </div>
      <v-text-field 
        v-model="days" 
        label="며칠동안 할까요?"
        prepend-icon="mdi-calendar-month-outline"
        hide-details
        type="number"
      ></v-text-field>
      <div class="customButtonBox2">
        <div 
          v-if="create === true" 
          class="customButton2 gray"
          @click="$router.push('/home')"
        >취소</div>
        <div 
          class="customButton2" 
          @click="createChallenge"
        >시작하기</div>
      </div>
      <overlay-loader :overlay="overlay" />
    </v-container>
    <span 
      v-if="alert"
      class="alert"
    >
      <v-icon class="alertIcon">mdi-alert</v-icon>
      {{ alertMessage }}
    </span>
  </div>
</template>
<script>
import OverlayLoader from "../../components/OverlayLoader.vue";
export default {
  name: "Start",
  components: {
    OverlayLoader,
  },
  methods: {
    createChallenge() {
      if(!this.reward){
        this.alert = true;
        this.alertMessage = '보상을 입력해주세요';
        return false;
      }
      if(!this.rewardImage){
        this.alert = true;
        this.alertMessage = '보상 이미지를 올려주세요';
        return false;
      }
      if(!this.days || this.days < 10){
        this.alert = true;
        this.alertMessage = '보상은 최소 10일부터 가능해요';
        return false;
      }
      this.overlay = true;

      let formData = new FormData();

      formData.append("reward", this.reward);
      formData.append("hint", this.hint);
      formData.append("days", this.days);
      formData.append("is_hint_visible", this.hintVisible ? 1 : 0);
      formData.append("image", this.rewardImage);

      // this.$axios
      //   .post("/challenges", formData, {
      //     headers: {
      //       "Content-Type": "multipart/form-data",
      //     },
      //   })
      //   .then((response) => {
      //     this.overlay = false;

      //     window.localStorage.setItem(
      //       "challengeInfo",
      //       JSON.stringify(response.data)
      //     );

      //     this.$store
      //       .dispatch("challenge", { body: response.data })
      //       .then(() => {
      //         this.$router.push("/pending");
      //       });
      //   });
      this.overlay = false;
      this.$router.push("/pending");
    },
  },
  data() {
    return {
      overlay: false,
      reward: undefined,
      hint: undefined,
      days: 10,
      hintVisible: true,
      create: false,
      rewardImage: undefined,
      alert: false,
      alertMessage: undefined,
    };
  },
  mounted(){
    if(window.localStorage.getItem('new')){
      this.create = true;
      window.localStorage.removeItem('new');
    }
    else if(window.localStorage.getItem('challengeInfo')){
      this.$router.push('/pending');
    }
  }
};
</script>
